<template>
  <div class="t-promocode" :class="{ active: promocodeVisible }">
    <transition name="promocode">
      <div v-if="!promocodeVisible" key="one" class="t-promocode__text-wrapper">
        <span class="t-promocode__text dashed" @click="setPromocodeVisible"
          >Активировать промокод</span
        >
      </div>
      <div v-else class="t-promocode__input-wrapper" key="two">
        <div class="t-form__input" :class="{ error: promoError }">
          <input
            ref="promocode-input"
            type="text"
            id="promo-code"
            v-model="promocode"
            @focus="clearPromocodeError"
            v-on:keyup.enter="submit"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: promocode }"
            for="promo-code"
            >Промокод</label
          >
          <span class="t-form__input-error">Промокод недействителен</span>
        </div>
        <transition name="promocode-button">
          <span
            v-if="!!promocode.trim()"
            class="t-promocode__text marginLeft"
            @click="submit"
            >Применить</span
          >
          <span v-else class="t-promocode__text marginLeft" @click="close">
            Закрыть
          </span>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';

export default {
  data: function() {
    return {
      promocodeVisible: false,
      promoError: false,
      promocode: '',
    };
  },
  computed: {
    ...mapState('api', ['promo']),
  },
  methods: {
    ...mapActions('api', ['fetchRequest']),
    ...mapMutations('cart', ['setPromocode']),

    form: function(data) {
      let _form = new FormData();
      Object.keys(data).forEach((item) => _form.append(item, data[item]));
      return _form;
    },
    setPromocodeVisible: function() {
      this.promocodeVisible = !this.promocodeVisible;
      if (this.promocodeVisible) {
        setTimeout(() => {
          this.$refs['promocode-input'].focus();
        }, 1);
      }
    },
    close: function() {
      this.promocodeVisible = false;
    },
    submit: function() {
      if (this.promocodeVisible) {
        this.fetchRequest({
          url: this.promo,
          form: this.form({
            promo: this.promocode,
          }),
          success: (data) => {
            console.log('success', data);
            if (data.body.success) {
              console.log('success promocode body true');
              this.setPromocode({
                promo: this.promocode,
                type: data.body.type,
                value: data.body.value,
              });
              this.setPromocodeVisible();
            } else {
              this.promoError = true;
            }
          },
          error: (e) => {
            console.log('data', this.promocode);
          },
        });
      }
    },
    clearPromocodeError: function() {
      this.promoError = false;
    },
  },
};
</script>
<style lang="sass" scoped>
@import './src/sass/params.sass'

.t-promocode
  position: relative
  margin-bottom: 24px
  z-index: 2
  height: 48px
  &__text
    font-size: 18px
    line-height: 20px
    font-weight: 500
    color: $secodary-blue-color
    cursor: pointer
    &.marginLeft
      margin-left: 24px
    &.dashed
      border-bottom: 1px dashed $secodary-blue-color
  &__input-wrapper
    display: flex
    align-items: center

  &__input-wrapper,
  &__text-wrapper
    position: absolute
    top: 0
    left: 0
    width: 100%

  &.error
    t-form__input
//
  .promocode-enter-active,
  .promocode-leave-active
    transition: all .3s

  .promocode-enter,
  .promocode-leave-to
    opacity: 0

  //
  .promocode-button-enter-active,
  .promocode-button-leave-active
    transition: all .5s

  .promocode-button-enter,
  .promocode-button-leave-to
    opacity: 0

  .t-form__input
    width: 45%
    margin-right: 15px
    input
      background-color: transparent

  @media screen and ( max-width: 1279px  )
    &.active
      margin-bottom: 70px
    &__text
      font-size: 14px
      line-height: 15px
    &__input-wrapper
      display: block
    .t-form__input
      width: 100%
      margin-bottom: 15px
</style>



// WEBPACK FOOTER //
// src/templates/components/ui/promocode.vue